import { render, staticRenderFns } from "./SimWrapper.vue?vue&type=template&id=58fd28b9&"
import script from "./SimWrapper.vue?vue&type=script&lang=js&"
export * from "./SimWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports